import { PhraseStatus } from "../../../api/phrasebook";

export const phraseColorByStatus: { [key: string]: string } = {
  empty: "lightgray",
  [PhraseStatus.UNREVIEWED]: "red",
  [PhraseStatus.INTERNALLY_REVIEWED]: "orange",
  [PhraseStatus.EXTERNALLY_REVIEWED]: "green",
};
